import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import InsumoRecord from '@components/InsumoRecord/InsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';

/**
 * Componente para tela de homeopatico
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function Homeopaticos(props) {
  useEffect(() => {
    const title = 'homeopatico.homeopatico';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <InsumoRecord
      chipData={props.chipData}
      infoUsuario={props.infoUsuario}
      insumoEnum={Insumo.HOMEOPATICO}
      insumoURL='homeopatico'
      viewKey='homeopatico'
      deleteMessageSucess={formatMessage('homeopatico.homeopaticoRemovidoComSucesso')}
      mensagemFalhaDeletar={formatMessage('homeopatico.falhaAoExcluirHomeopatico')}
      mensagemDelete={formatMessage('homeopatico.desejaExcluir')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info,
  chipData: state.chips.chipData.filter(date => {
    return date.id === 'homeopatico';
  })[0].content
});

export default connect(mapStateToProps)(Homeopaticos);
